import { CloseIconSt as CloseButton } from './FullscreenButton.css';
import { usePlayMedia } from 'app/providers/PlayVideoProvider';
import { trackAction } from 'app/utils/tracking';
import { Close } from '@heycar-uikit/icons';

interface IFullscreenButtonProps {
  onClose: () => void;
}

export const FullscreenButton = ({ onClose }: IFullscreenButtonProps) => {
  const { setMediaPlayMode, fullScreenAndPlay } = usePlayMedia();

  const onCloseButtonClick = e => {
    e.stopPropagation();
    e.preventDefault();
    if (fullScreenAndPlay) {
      trackAction('vehicle_video_gallery_close', {
        category: 'PDP',
        description: 'User clicks on video gallery close button',
      });
    }
    setMediaPlayMode(false);
    onClose();
  };

  return (
    <CloseButton onClick={onCloseButtonClick} aria-label="close">
      <Close fontSize={20} />
    </CloseButton>
  );
};
